var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"modal flex__center"},[_c('Ticketing',{attrs:{"ticketNum":_vm.ticketNum},on:{"toggleTicketing":_vm.emitToggleTicketing}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }